<template>
    <div id="file-container">
        <!-- <p v-if="isLoading || error">Loading file...</p>
        <p v-if="error">Error: {{ error }}</p>-->
        <!-- v-if="fileUrlData" -->
        <v-btn
            v-if="fileDialogVisible"
            style="margin-bottom: 20px; background-color: #009688; color: white;" 
            @click="fetchFile"
        >
            <v-icon>{{ mdiDownload }}</v-icon>DOWNLOAD AUTHORIZATION SLIP
        </v-btn> 
    <!-- <v-dialog 
            style="z-index: 100"
            v-model="fileDialogVisible" 
            max-width="lg"
        >
            <v-card>
                <v-card-text>
                    <div v-if="fileUrlData.type == 'application/pdf'">
                        <object ref="fileObject" data="" type="application/pdf" width="100%" height="600px">
                            <p>No PDF available</p>
                        </object>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn 
                        text 
                        @click="show = false"
                        color="error"
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->
    </div>
</template>

<script>
import { mdiDownload } from '@mdi/js'
import { saveAs } from 'file-saver'
import { base64ToBlob } from '../../../utils/helpers'
export default {
    props: ['pdfData'],
    data: () => ({
        mdiDownload,
        isLoading: false,
        error: null,
        show: false,
        fileUrlData: null,
        fileUrl: '',
        isPdf: true
    }),
    computed: {
        fileDialogVisible: {
            get() {
                this.saveFile(this.pdfData)
                return true
            },
            set(val) {
                this.closeDialog(val)
            }
        }
    },
    watch: {
        pdfData(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.saveFile(newVal)
            }
        }
    },
    methods: {
        saveFile(file) {
            this.fileUrlData = file
        },
        closeDialog(val) {
            this.show = val
        },
        async fetchFile() {
            this.isLoading = true
            try {
                const { url, type, fileName } = this.fileUrlData
                const blob = base64ToBlob(url, type)
                saveAs(blob, `${fileName}.pdf`)
            } catch (error) {
                this.error = 'Something went wrong: ' + error.message
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>
